export var SUBSCRIPTION_FEE = "SUBSCRIPTION_FEE";
